const FlagFootballPrograms = [
  {
    id: 1,
    title: "FLAG FOOTBALL REGISTRATION",
    description: "",
    startDate: "2026-08-25",
    endDate: "2026-09-26",
    dates: "October 16 - November 20",
    playoffs: "December 11th",
    ageGroup: "K-8th",
    price: "Regular - $175, Late - $195",
    location:
      "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
    locationUrl:
      "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",
    registrationUrl:
      "https://app.teampass.com/product/227497?a=1&sid=9813_A847EA42EFC2059D8EC7AA4A6E646356"
  }
];

export default FlagFootballPrograms;